<template>
  <div>
    <div class="data-table-title">
      <div class="data-table-description">
        一斉送信機能を使って送信したメッセージの履歴を確認できます。直近のメッセージ20件のみが表示されます。
      </div>
      <el-button type="primary" icon="el-icon-refresh-right" @click="loadBulkHistory()">ステータスを更新</el-button>
    </div>
    <div class="data-table-message" :class="header_notification ? 'header-notification-space-120' : ''">
      <div class="data-table-th-ellipsis">メッセージ</div>
      <div class="data-table-th-160">送信アカウント</div>
      <div class="data-table-th-100">ステータス</div>
      <div class="data-table-th-50">送信先</div>
      <div class="data-table-th-50">送信済</div>
      <div class="data-table-th-50">送信中止</div>
      <div class="data-table-th-50">送信不可</div>
      <div class="data-table-th-50">送信失敗</div>
      <div class="data-table-th-140">送信開始時間</div>
      <div class="data-table-th-80">操作</div>
    </div>
    <div class="data-table-th-loading" v-loading="loading" v-if="loading"></div>
    <div class="data-table-list-nolist" v-if="no_massage && !loading">
      <img src="../../assets/chat_image.png" style="opacity:0.5" alt />
      <div style="font-size:20px; font-weight:700; margin-bottom:15px;">メッセージ送信リストがありません</div>
      <div class="data-table-list-nolist-content">「インフルエンサーリスト」から送信された一斉メッセージのみが表示されます</div>
    </div>
    <div v-if="!loading">
      <div v-for="(message, message_index) in message_list" v-bind:key="message.id" class="data-table-list-tr" style="cursor:pointer" @click="openBulkDetail(message_index, message.message_id)">
        <div class="data-table-th-ellipsis" style="margin-right:20px">{{ message.message }}</div>
        <div class="data-table-th-160">
          <el-image :src="s3BaseUrl + '/profile_picture/' + message.sender + '.jpg'" class="data-table-profile bulk" style="margin-right: 10px;">
            <div slot="error" class="data-table-profile-noimg">
              <i class="el-icon-user-solid"></i>
            </div>
          </el-image>
          {{ message.sender }}
        </div>
        <div class="data-table-th-100">
          <div
            class="status-button-small"
            :class="
              message.status == 'wait'
                ? 'info'
                : message.status == 'sending'
                ? 'primary'
                : message.status == 'sent'
                ? 'success'
                : message.status == 'cancelled'
                ? 'warning'
                : message.status == 'failed'
                ? 'danger'
                : 'info'
            "
          ></div>
          {{
            message.status == "wait"
              ? "待機中"
              : message.status == "sending"
              ? "送信中"
              : message.status == "sent"
              ? "完了"
              : message.status == "cancelled"
              ? "送信中止"
              : message.status == "failed"
              ? "送信失敗"
              : ""
          }}
        </div>
        <div class="data-table-th-50">{{ message.recipient_num }}</div>
        <div class="data-table-th-50">{{ message.sent_num }}</div>
        <div class="data-table-th-50">{{ message.cancelled_num }}</div>
        <div class="data-table-th-50">{{ message.unsendable_num }}</div>
        <div class="data-table-th-50">{{ message.failed_num }}</div>
        <div class="data-table-th-140">{{ message.created_at }}</div>
        <div class="data-table-th-80">
          <el-button type="danger" size="mini" v-if="message.status == 'sending' || message.status == 'wait' || message.status == 'sending'" @click.stop="cancelSending(message.message_id)"
            >送信中止</el-button
          >
          <el-button type="info" size="mini" v-else @click.stop="deleteSending(message.message_id)">履歴削除</el-button>
        </div>
      </div>
    </div>

    <!-- drawer -->
    <div class="bulk-detail-modal" :class="[bulk_detail_modal ? 'open' : '']">
      <div v-if="bulk_detail_modal" style="width:100%">
        <div class="bulk-detail-title" v-if="checkList.length == 0">一斉送信リスト</div>
        <div class="bulk-detail-title sticky" v-if="checkList.length > 0">
          <div class="check-wrap" style="display:flex; width:calc(100% - 20px)">
            <div class="check-parts" style="color:#666">{{ checkList.length }}名を選択中</div>
            <el-dropdown trigger="click" placement="bottom-start">
              <span class="check-parts pointer" style="font-size:11px; font-weight: 700; color:#0095f6"><i class="el-icon-circle-plus-outline" style="font-size:14px;"></i>一括選択</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="checkAll('all')">全員を一括選択</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('sent')">送信完了を一括選択</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('failed')">送信中止・失敗を一括選択</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="check-parts pointer" @click="checkList = []"><i class="el-icon-remove-outline" style="font-size:14px;"></i>選択を解除</div>
            <div class="flex-space"></div>
            <el-button v-if="is_deletable" type="danger" size="small" style="margin-right:10px" @click="deleteRecipient(checkList, 'bulk')">
              <i class="el-icon-delete"></i>
              削除</el-button
            >
            <addListButton :checkList.sync="checkList" :sns_type="'instagram'" />
          </div>
        </div>
        <div class="bulk-detail-notifybox" v-if="message_list[message_index].status == 'cancelled' || message_list[message_index].status == 'failed'">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" style="margin-right: 5px;" />一部の送信先が送信失敗または送信中止状態です。
          <div class="flex-space"></div>
          <el-tooltip :disabled="sessionid_is_active">
            <div slot="content">このメッセージは再送信できません</div>
            <span>
              <el-button
                type="danger"
                size="mini"
                @click="retrySendingAll(message_list[message_index].sessionid)"
                v-if="message_list[message_index].status == 'failed' || message_list[message_index].status == 'cancelled'"
                :disabled="!sessionid_is_active"
                >再送信</el-button
              >
            </span>
          </el-tooltip>
        </div>
        <div class="bulk-detail-notifybox warning" v-else-if="message_list[message_index].status == 'wait' && sendable">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" style="margin-right: 5px;" />
          このメッセージは待機中です。通常1~2分程度で送信が開始されます。他のメッセージが送信中の場合、他のメッセージの送信が完了するまで待機します。
        </div>
        <div class="bulk-detail-notifybox warning" v-else-if="message_list[message_index].status == 'wait'">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" style="margin-right: 5px;" />このメッセージは送信可能時間外のため待機中です。
          <div class="flex-space"></div>
          <el-button type="warning" size="mini" @click="cancelSending(message_list[message_index].message_id)">送信を中止</el-button>
        </div>
        <div class="bulk-detail-notifybox primary" v-if="message_list[message_index].status == 'sending'">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" style="margin-right: 5px;" />このメッセージは現在送信中です。
          <div class="flex-space"></div>
          <el-button type="primary" size="mini" @click="loadBulkDetail()" v-if="message_list[message_index].status == 'sending'">送信状況を更新</el-button>
          <el-button type="danger" size="mini" @click="cancelSending(message_list[message_index].message_id)" v-if="message_list[message_index].status == 'sending'">送信を中止</el-button>
        </div>

        <div class="bulk-detail-subtitle">送信者・送信日時</div>
        <div class="bulk-detail-box sender">
          <el-image :src="s3BaseUrl + '/profile_picture/' + message_list[message_index].sender + '.jpg'" class="data-table-profile list" style="margin-right: 10px;">
            <div slot="error" class="data-table-profile-noimg">
              <i class="el-icon-user-solid"></i>
            </div>
          </el-image>
          <div>
            <div style="font-weight: 600; margin-bottom:3px">{{ message_list[message_index].sender }}</div>
            <div class="bulk-detail-sender-info">
              <div>{{ message_list[message_index].created_at }}に送信開始</div>
              <div style="position:relative">
                <div class="router-link" @click="option = true" v-if="message_list[message_index].option_span">・送信オプションを確認</div>
                <transition name="fade">
                  <div class="data-table-cost-popup bottom history" v-show="option">
                    <div class="inbox-phrase-popup-title">メッセージの送信間隔</div>
                    <div class="inbox-phrase-popup-radio-wrap">
                      <div class="inbox-phrase-popup-radio left">
                        <el-radio disabled v-model="option_span" label="speedy">スピーディ</el-radio>
                        <el-tooltip>
                          <div slot="content">2~3分程度の間隔でメッセージが送信されます。スパムとみなされる可能性が高くなります。</div>
                          <span>
                            <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: -5px;" />
                          </span>
                        </el-tooltip>
                      </div>
                      <div class="inbox-phrase-popup-radio">
                        <el-radio disabled v-model="option_span" label="nomal">通常(推奨)</el-radio>
                        <el-tooltip>
                          <div slot="content">6~8分程度の間隔でメッセージが送信されます。</div>
                          <span>
                            <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: -5px;" />
                          </span>
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="divider full"></div>
                    <div class="inbox-phrase-popup-title">
                      送信完了・失敗をメールで通知
                      <div class="flex-space"></div>
                      <el-switch disabled v-model="option_mail"></el-switch>
                    </div>
                    <div class="divider full"></div>
                    <div class="inbox-phrase-popup-title">
                      送信失敗時に送信を続行
                      <div class="flex-space"></div>
                      <el-switch disabled v-model="option_ongoing"></el-switch>
                    </div>
                    <div class="inbox-phrase-popup-radio-wrap column" v-if="option_ongoing">
                      <div class="inbox-phrase-popup-radio left">
                        <el-radio disabled v-model="option_ongoing_type" label="instantly">即座に再送信を続行</el-radio>
                      </div>
                      <div class="inbox-phrase-popup-radio">
                        <el-radio disabled v-model="option_ongoing_type" label="later">翌日以降に再送信を続行</el-radio>
                      </div>
                      <div style="margin-top:10px">
                        <el-time-select align="center" size="mini" disabled v-model="message_list[message_index].option_ongoing_date"></el-time-select>
                      </div>
                    </div>
                    <div class="divider full"></div>
                    <div class="inbox-phrase-popup-title">
                      メッセージ送信可能時間
                      <div class="flex-space"></div>
                      <el-switch disabled v-model="option_sendable_time_switch"></el-switch>
                    </div>
                    <div style="color:#aaa; font-size:8px; margin-bottom:10px;">以下の時間帯でのみ送信を実行する</div>
                    <div>
                      <el-time-select align="center" size="mini" disabled v-model="option_sendable_time"></el-time-select>
                    </div>
                  </div>
                </transition>
                <div class="cost-overlay" v-show="option" @click="option = false"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="bulk-detail-subtitle">送信内容</div>
        <div class="bulk-detail-box">
          <pre class="bulk-detail-content" :class="message_detail ? 'detail' : ''">{{ message_list[message_index].message }}</pre>
          <div @click="messageDetail()" class="router-link">{{ message_detail ? "縮小表示" : "全て表示" }}</div>
        </div>
        <div class="bulk-detail-subtitle row">送信先</div>
        <div style="margin-bottom: 15px;">
          <span style="font-weight:400; font-size:11px; color:#666;">
            <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 3px;" />
            各送信先へのメッセージは{{ message_list[message_index].option_span == "nomal" ? "6~8分" : "2~3分" }}程度の間隔を空けて送信されています。
          </span>
        </div>
        <div class="bulk-detail-box">
          <div class="bulk-detail-recipient" v-for="(recipient, recipient_index) in recipient_list" :key="recipient.id">
            <div class="data-table-th-checkbox">
              <input type="checkbox" class="checkbox-original" v-model="checkList" :value="recipient.ig_id" :id="recipient.ig_id + 'checkbox'" />
              <label class="checkbox_inner" :for="recipient.ig_id + 'checkbox'"> </label>
            </div>
            <el-image v-bind:src="recipient.profile_picture_url" class="data-table-profile bulk" style="margin-right: 10px;">
              <div slot="error" class="data-table-profile-noimg">
                NO
                <br />IMAGE
              </div>
            </el-image>
            <div class="bulk-detail-recipient-name">{{ recipient.account_name }}・{{ recipient.username }}</div>
            <div class="flex-space"></div>
            <el-tooltip placement="top-end">
              <div slot="content">
                <div v-if="recipient.status == 'failed' && sessionid_is_active && recipient.message_log && recipient.message_log.includes('Character limit exceeded')">このメッセージは再送信できません。<br>パーソナライズ項目を含むメッセージの文字数が1000字を超えているため、送信できませんでした。</div>
                <div
                  v-if="(recipient.status == 'failed' || recipient.status == 'cancelled') && sessionid_is_active && recipient.message_log && !recipient.message_log.includes('Character limit exceeded')"
                  class="pointer"
                  @click="recipient.status == 'failed' || recipient.status == 'cancelled' ? retrySending(recipient.ig_id, recipient_index, message_list[message_index].sessionid) : ''"
                >
                  メッセージの再送信
                </div>
                <div v-if="(recipient.status == 'failed' || recipient.status == 'cancelled') && !sessionid_is_active">このメッセージは再送信できません</div>
                <div v-if="recipient.status == 'unsendable'">送信先アカウントがDMをブロックしている、<br />または送信先アカウントが削除されている等の理由により送信不可の状況です。</div>
                <div v-if="recipient.status == 'sent'">{{ recipient.sent_at }}に送信</div>
                <div v-if="recipient.status == 'wait'" class="pointer" @click="deleteRecipient([recipient.ig_id], 'single', recipient_index)">送信リストから削除</div>
              </div>
              <div class="bulk-detail-recipient-status">
                <div
                  class="status-button-small"
                  :class="
                    recipient.status == 'wait'
                      ? 'info'
                      : recipient.status == 'failed'
                      ? 'danger'
                      : recipient.status == 'unsendable'
                      ? 'danger'
                      : recipient.status == 'sent'
                      ? 'success'
                      : recipient.status == 'cancelled'
                      ? 'warning'
                      : 'info'
                  "
                ></div>
                {{
                  recipient.status == "wait"
                    ? "待機中"
                    : recipient.status == "failed"
                    ? "送信失敗"
                    : recipient.status == "unsendable"
                    ? "送信不可"
                    : recipient.status == "sent"
                    ? "送信完了"
                    : recipient.status == "cancelled"
                    ? "送信中止"
                    : ""
                }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-bind:class="[bulk_detail_modal ? 'overlay open' : 'overlay']" @click="closeBulkDetail(), (option = false)"></div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadBulkHistoryAPI = root + "/api/message/load_bulkHistory";
const loadRecipientAPI = root + "/api/message/load_recipient";
const cancelSendingAPI = root + "/api/message/broadcast_bulk_cancel";
const deleteSendingAPI = root + "/api/message/broadcast_bulk_delete";
const retrySendingAPI = root + "/api/message/broadcast_bulk_retry";
const retrySendingAllAPI = root + "/api/message/broadcast_bulk_retry_all";
const deleteRecipientAPI = root + "/api/message/delete_recipient";
import addListButton from "../list/add_list_button.vue";

export default {
  name: "bulkHistory",
  props: [],
  components: {
    addListButton,
  },
  data() {
    return {
      message_list: [],
      message_index: -1,
      message_id: "",
      loading: true,
      no_massage: false,
      bulk_detail_modal: false,
      recipient_list: [],
      message_detail: false,
      option: false,
      sessionid_is_active: false,
      checkList: [],
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    option_span() {
      return this.message_list[this.message_index].option_span;
    },
    option_comment() {
      if (this.message_list[this.message_index].option_comment_text) {
        return true;
      } else {
        return false;
      }
    },
    option_mail() {
      if (this.message_list[this.message_index].option_mail == "1") {
        return true;
      } else {
        return false;
      }
    },
    option_ongoing() {
      if (this.message_list[this.message_index].option_ongoing == "1") {
        return true;
      } else {
        return false;
      }
    },
    option_ongoing_type() {
      if (this.message_list[this.message_index].option_ongoing_type) {
        return this.message_list[this.message_index].option_ongoing_type;
      } else {
        return null;
      }
    },
    option_sendable_time_switch() {
      if (this.message_list[this.message_index].option_sendable_time == "" || this.message_list[this.message_index].option_sendable_time == "00:00-24:00") {
        return false;
      } else {
        return true;
      }
    },
    option_sendable_time() {
      if (this.message_list[this.message_index].option_sendable_time == "" || this.message_list[this.message_index].option_sendable_time == "00:00-24:00") {
        return "00:00-24:00";
      } else {
        return this.message_list[this.message_index].option_sendable_time;
      }
    },
    sendable() {
      var sendable_time = this.message_list[this.message_index].option_sendable_time;
      var from = sendable_time.split("-")[0];
      var to = sendable_time.split("-")[1];
      var now = new Date().getHours() + ":" + new Date().getMinutes();
      if (from <= now && now <= to) {
        return true;
      } else {
        return false;
      }
    },
    is_deletable() {
      var sent_recipient = 0;
      for (let i = 0; i < this.checkList.length; i++) {
        for (let ii = 0; ii < this.recipient_list.length; ii++) {
          if (this.checkList[i] == this.recipient_list[ii].ig_id) {
            if (this.recipient_list[ii].status == "sent") sent_recipient += 1;
          }
        }
      }
      if (sent_recipient > 0 || this.checkList.length == 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.loadBulkHistory();
  },
  methods: {
    loadBulkHistory() {
      this.loading = true;
      this.axios
        .get(loadBulkHistoryAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.message_list = response.data.message_list;
          if (this.message_list.length == 0) {
            this.no_massage = true;
          }
          setTimeout(() => {
            this.loading = false;
          }, 300);
        })
        .catch(() => {});
    },
    openBulkDetail(message_index, message_id) {
      this.sessionid_is_active = false;
      this.message_index = message_index;
      this.message_id = message_id;
      this.bulk_detail_modal = true;
      document.documentElement.style.overflow = "hidden";
      for (let i = 0; i < this.ig_info.length; i++) {
        if (this.ig_info[i].sessionid == this.message_list[this.message_index].sessionid && !this.ig_info[i].login_required) {
          this.sessionid_is_active = true;
        }
      }
      this.loadBulkDetail();
    },
    closeBulkDetail() {
      document.documentElement.style.overflow = "auto";
      this.bulk_detail_modal = false;
      this.checkList = [];
    },
    loadBulkDetail() {
      this.bulk_detail_loading = true;
      this.recipient_list = [];
      this.axios
        .get(loadRecipientAPI, {
          params: {
            token: this.token,
            message_id: this.message_id,
          },
        })
        .then((response) => {
          this.recipient_list = response.data.recipient_list;
          this.bulk_detail_loading = false;
        })
        .catch(() => {});
    },
    messageDetail() {
      this.message_detail = !this.message_detail;
    },
    cancelSending(message_id) {
      this.$confirm("未送信メッセージの送信を中止できます。既に送信されているメッセージは中止できません。", "メッセージの送信を中止しますか？", {
        confirmButtonText: "中止",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("message_id", message_id);
          this.axios
            .post(cancelSendingAPI, params)
            .then((response) => {
              this.$alert(response.data.cancelled_num + "名の送信を取り消しました", "メッセージの送信を取り消しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
              this.loadBulkHistory();
              this.loadBulkDetail();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    deleteSending(message_id) {
        this.$confirm("この操作は取り消せません。", "メッセージ履歴を削除しますか？", {
          confirmButtonText: "削除",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
          type: "warning",
        })
          .then(() => {
            var params = new URLSearchParams();
            params.append("token", this.token);
            params.append("message_id", message_id);
            this.axios
              .post(deleteSendingAPI, params)
              .then(() => {
                this.$alert("メッセージ履歴を削除しました", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "success",
                });
                this.loadBulkHistory();
                this.loadBulkDetail();
              })
              .catch(() => {});
          })
          .catch(() => {});
    },
    retrySending(ig_id, recipient_index, sessionid) {
      this.$confirm("メッセージは1~2分後に送信されます。", "メッセージを再送信しますか？", {
        confirmButtonText: "再送信",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("sessionid", sessionid);
          params.append("message_id", this.message_id);
          params.append("ig_id", ig_id);
          this.axios
            .post(retrySendingAPI, params)
            .then((response) => {
              if (response.data.status == "ok") {
                this.$alert("メッセージの再送信予約を行いました。", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "success",
                });
                this.recipient_list[recipient_index].status = "wait";
                this.closeBulkDetail();
                this.loadBulkHistory();
              } else {
                this.$alert("メッセージの再送信に失敗しました", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "error",
                });
                this.recipient_list[recipient_index].status = "wait";
                this.closeBulkDetail();
                this.loadBulkHistory();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    retrySendingAll(sessionid) {
      this.$confirm(
        "送信失敗・送信中断先にメッセージを再送します。<br><ul style='list-style: unset; padding:0 0 0 20px; margin: 12px 0 0 0'><li style='list-style:unset'>Instagram側でDM規制がかかっている状況で再送信を繰り返すと、一時的にロックされたり、最悪の場合アカウントが凍結されてしまう場合があります。</li><li style='list-style:unset'>必ず規制が解除されてから再送信を行ってください。</li></ul>",
        "メッセージを再送信しますか？",
        {
          confirmButtonText: "注意事項に同意して再送信",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("sessionid", sessionid);
          params.append("message_id", this.message_id);
          this.axios
            .post(retrySendingAllAPI, params)
            .then((response) => {
              if (response.data.status == "ok") {
                this.$alert("メッセージの再送信予約を行いました。", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "success",
                });
                this.closeBulkDetail();
                this.loadBulkHistory();
              } else {
                this.$alert("メッセージの再送信に失敗しました", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "error",
                });
                this.closeBulkDetail();
                this.loadBulkHistory();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    deleteRecipient(recipient, delete_type, recipient_index) {
      this.$confirm(recipient.length + "名のインフルエンサーを送信リストから削除しますか?", "送信リストから削除", {
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("message_id", this.message_id);
          params.append("recipient", JSON.stringify(recipient));
          this.axios
            .post(deleteRecipientAPI, params)
            .then((response) => {
              if (response.data.status == "ok") {
                if (delete_type == "bulk") {
                  this.$message({
                    type: "success",
                    offset: 7,
                    showClose: true,
                    message: recipient.length + "名のインフルエンサーを送信リストから削除しました",
                  });
                  this.loadBulkDetail();
                  this.loadBulkHistory();
                  this.checkList = [];
                } else if (delete_type == "single") {
                  this.$message({
                    type: "success",
                    offset: 7,
                    showClose: true,
                    message: "送信リストから削除しました",
                  });
                  this.$delete(this.recipient_list, recipient_index);
                  this.loadBulkHistory();
                }
              } else {
                this.$alert("削除に失敗しました", {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "error",
                });
                this.loadBulkHistory();
              }
            })
            .catch(() => {
              this.checkList = [];
            });
        })
        .catch(() => {});
    },
    checkAll(type) {
      const allInfluencer = [];
      for (let i = 0; i < this.recipient_list.length; i++) {
        var status = this.recipient_list[i].status;
        if (type == "all") {
          allInfluencer.push(this.recipient_list[i].ig_id);
        } else if (type == "sent") {
          if (status == "sent") {
            allInfluencer.push(this.recipient_list[i].ig_id);
          }
        } else if (type == "failed") {
          if (status == "faliled" || status == "cancelled") {
            allInfluencer.push(this.recipient_list[i].ig_id);
          }
        }
      }
      this.checkList = allInfluencer;
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
};
</script>
